<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also By Rob Sinclair</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="underline"><span class="smallcaps">The James Ryker Series:</span></span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Red Cobra</span> #1</p>
<p class="subsq also-by-content"><span class="content-external-link">The Black Hornet</span> #2</p>
<p class="subsq also-by-content"><span class="content-external-link">The Silver Wolf</span> #3</p>
<p class="subsq also-by-content"><span class="content-external-link">The White Scorpion</span> #5</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="underline"><span class="smallcaps">The Enemy Series:</span></span></p>
<p class="subsq also-by-content">Dance with the Enemy</p>
<p class="subsq also-by-content">Rise of the Enemy</p>
<p class="subsq also-by-content">Hunt for the Enemy</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content">Dark Fragments</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobyrobsinclair.vue?78b7a0e3